import { Select } from "antd";
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { IVesselOfUser } from "../../../../pages/LoginPage/constants";
import { loginActions } from "../../../../pages/LoginPage/reducer";
import { selectPermissions, selectViewMode } from '../../../../util/store/selectors';
import { getStore, useSelector } from "../../../../util/store/store";
import { propContainer } from "../../../../util/varibles/constants";
import { filterOption } from "../../../../util/varibles/global";
import { VIEW_MODE } from "../../../../util/varibles/permission";
import { PreferenceSetting } from "../../../../util/varibles/userSetting";
import styles from './style.module.scss';

const KEY_SPLIT = '_';


interface IProps {
}

const ViewMode: React.FC<IProps> = () => {
    const [mode, setMode] = useState('');
    const dispatch = useDispatch();
    const viewMode = useSelector(selectViewMode);
    const [vesselViewer, plannerViewer, siteViewer] = useSelector(selectPermissions([VIEW_MODE.VESSEL, VIEW_MODE.PLANNER, VIEW_MODE.SITE]));
    const vessels = useSelector(state => state.login.vessels);
    const loading = useSelector(state => state.login.loadingDashboard);

    const initVesselsRef = useRef(() => { dispatch(loginActions.getOpsOfVessel()) })
    const initModeRef = useRef((vessels: IVesselOfUser[] = []) => {
        let mode: string = "";
        if (viewMode === VIEW_MODE.VESSEL && vesselViewer) {
            const { default_vessel } = getStore().login.user;
            const { vessel_id = null } = (vessels || []).find(item => item.vessel_id === default_vessel) || vessels[0] || {};
            if (vessel_id) {
                if (!default_vessel) {
                    dispatch(loginActions.updateUserSetting([{}, { default_vessel: vessel_id }]))
                }
                mode = [VIEW_MODE.VESSEL, vessel_id].join(KEY_SPLIT);
            } else
                mode = '';
        } else if (!viewMode)
            mode = plannerViewer ? VIEW_MODE.PLANNER : VIEW_MODE.SITE;
        else
            mode = viewMode;
        setMode(mode);
    })

    useEffect(() => {
        if (vesselViewer) {
            initVesselsRef.current?.();
            initVesselsRef.current = () => { };
        } else {
            initModeRef.current();
        }
    }, [vesselViewer]);

    useEffect(() => {
        if (!loading && vessels.length > 0) {
            initModeRef.current(vessels);
        }
    }, [loading, vessels]);

    const opts = useMemo(() => {
        const result = [];
        if (plannerViewer) {
            result.push({ label: "Planner view", value: VIEW_MODE.PLANNER })
        }
        if (siteViewer) {
            result.push({ label: "Site view", value: VIEW_MODE.SITE })
        }
        if (vesselViewer) {
            (vessels || []).forEach(item => result.push({ label: `${item.name} view`, value: [VIEW_MODE.VESSEL, item.vessel_id].join(KEY_SPLIT) }))
        }
        return result
    }, [plannerViewer, siteViewer, vesselViewer, vessels])

    if (opts.length <= 1 || mode.length === 0)
        return null;

    const handleChange = (id: string) => {
        const [modeView, vesselId] = id.split(KEY_SPLIT);
        dispatch(loginActions.updateUserSetting([
            { [PreferenceSetting.VIEW_MODE]: modeView },
            { default_vessel: vesselId || '' }
        ]))
        setMode(id);
    }

    return <div className={styles.wrapper}>
        <Select
            {...propContainer}
            showSearch={{
                filterOption
            }}
            className={styles.select}
            value={mode}
            popupMatchSelectWidth={false}
            placement={"bottomRight"}
            variant="borderless"
            onChange={handleChange}
            options={opts}
        />
    </div>;
};


export default React.memo(ViewMode, () => true);